import { useSelector } from "react-redux";

import React, { useCallback } from "react";
import { Button } from "antd";
import dayjs from "../../../utils/dayjs";
import { typeIntervention } from "../../../utils/constants";
import { AiOutlineCalendar } from "react-icons/ai";
import { t } from "i18next";

const DownloadICS = ({ type = "button" }) => {
  const { prestation, loading } = useSelector(state => state.prestation);

  const downloadIcsFile = useCallback(() => {
    const {
      startDate,
      endDate,
      location,
      type,
      linkVisio,
      phone,
      extra,
    } = prestation.intervention;

    const { applicant } = prestation;

    // Norm al dayjs for timezone automatic
    let icsMSG = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DESCRIPTION:Prestation de traduction - ${extra} ${
      type === typeIntervention.phone ? phone : ""
    } - OSEO VALAIS
DTSTART:${dayjs(startDate)
      .utc()
      .format("YYYYMMDDTHHmmss[Z]")}
DTEND:${dayjs(endDate)
      .utc()
      .format("YYYYMMDDTHHmmss[Z]")}
SUMMARY:OSEO AVIC - (${prestation?.reference || ""})
`;

    if (type === typeIntervention.in_person) {
      icsMSG += `LOCATION:${location}\n`;
    }
    if (applicant?.email) {
      let contactInfo = [];
      contactInfo.push(applicant?.name);
      contactInfo.push(applicant?.email);

      if (contactInfo.length > 0) {
        icsMSG += `CONTACT:${contactInfo.join("; ")}\n`;
      }
    }

    if (type === typeIntervention.visio) {
      icsMSG += `URL:${linkVisio}\n`;
    }

    icsMSG += "END:VEVENT\nEND:VCALENDAR";

    const blob = new Blob([icsMSG], { type: "text/calendar" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `${prestation?.reference || "event"}.ics`;

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }, [prestation, loading]);

  if (type === "link") {
    return (
      <a onClick={downloadIcsFile}>
        <span style={{ marginLeft: 5, marginRight: 10 }}>
          <AiOutlineCalendar size={15} />
        </span>
        {t("prestationAction.addToMyCalendar")}
      </a>
    );
  }

  if (type === "button") {
    return (
      <Button
        onClick={downloadIcsFile}
        size={"large"}
        className={"confirmButton forceRed"}
        type={"primary"}
      >
        {t("prestationAction.addToMyCalendar")}
      </Button>
    );
  }
};

export default DownloadICS;
